import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { IOuter } from '../EmptyState.types';

export const PurchasedSubtitle: FC<IOuter> = () => <FormattedMessage id="empty-state.purchased-folder-subtitle" />;
